import { useState } from "react"

import { Segmented } from "antd"
import { useSelector } from "react-redux"

import Private from "../../../Components/Private"
import { PRICING_TAB } from "../../PricingPage/redux/pricing.constants"
import TitleSection from "../components/TitleSection"
import AlertsTab from "./components/AlertsTab"
import LookupsTab from "./components/LookupsTab"

import styles from "./styles.module.less"

// Segmented options don't forward attributes, so the id rides on the label node.
const PRICING_TAB_OPTIONS = [
  {
    value: PRICING_TAB.ALERTS,
    label: <span data-testid="business-pricing-tab-alerts">Alerts</span>
  },
  {
    value: PRICING_TAB.LOOKUPS,
    label: <span data-testid="business-pricing-tab-lookups">Lookups</span>
  }
]

const PRICING_TAB_COMPONENTS = {
  [PRICING_TAB.ALERTS]: AlertsTab,
  [PRICING_TAB.LOOKUPS]: LookupsTab
}

const Pricing = () => {
  const businessAccount = useSelector((state) => state.user.businessAccount)
  const [activeTab, setActiveTab] = useState(PRICING_TAB.ALERTS)

  const ActiveTab = PRICING_TAB_COMPONENTS[activeTab]

  return (
    <div className={styles.page}>
      <TitleSection
        title={
          <>
            {"Pricing for "}
            <Private>{businessAccount?.name}</Private>
          </>
        }
        link={businessAccount?.url}
        testIdPrefix="business-pricing"
      />

      <Segmented
        options={PRICING_TAB_OPTIONS}
        value={activeTab}
        onChange={setActiveTab}
        size="large"
        className={styles.tabs}
      />

      <ActiveTab />
    </div>
  )
}

export default Pricing
